// components/reusable/ExerciseVideo.js
import React, { useRef, useEffect, useState } from "react";

export default function ExerciseVideo({
  src,
  autoPlay = true,
  loop = true,
  muted = true,
  controls = false,
  playsInline = true,
  preload = "auto",
  poster,
  className = "",
  style = {},
}) {
  const videoRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true); 

    const videoEl = videoRef.current;
    let playPromise;

    if (videoEl) {
      videoEl.muted = muted;
      if (autoPlay) {
        playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      }
    }

    return () => {
      if (playPromise !== undefined) {
        playPromise.then(() => videoEl?.pause()).catch(() => {});
      } else {
        videoEl?.pause();
      }
    };
  }, [src, muted, autoPlay]);

  return (
    <>
      <style>
        {`
          .exercise_video_wrapper {
            position: relative;
            width: 60vw;
            height: 60vh;
            margin: 0 auto;
          }

          @media (max-width: 992px) {
            .exercise_video_wrapper {
              width: 100%;
              height: auto;
            }
          }

          .exercise_video {
            width: 100%;
            height: 100%;
            // object-fit: cover;
            border-radius: 12px;
            display: block;
          }

          .exercise_video_skeleton {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            background: linear-gradient(
              90deg,
              #1c1f2e 25%,
              #2a2f45 37%,
              #1c1f2e 63%
            );
            background-size: 400% 100%;
            animation: exercise_video_shimmer 1.4s ease infinite;
          }

          @keyframes exercise_video_shimmer {
            0% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0 50%;
            }
          }
        `}
      </style>

      <div className="exercise_video_wrapper">
        {isLoading && <div className="exercise_video_skeleton" />}
        <video
          key={src}
          ref={videoRef}
          src={src}
          loop={loop}
          controls={controls}
          playsInline={playsInline}
          preload={preload}
          poster={poster}
          onLoadedData={() => setIsLoading(false)}
          onCanPlay={() => setIsLoading(false)}
          className={`exercise_video ${className}`}
          style={{ ...style, visibility: isLoading ? "hidden" : "visible" }}
        />
      </div>
    </>
  );
}